import React, { useEffect, useState } from 'react';
import vwhite from 'assets/vestiwhite.svg';
import Visa from 'assets/VisaIcon.svg';
import Mastercard from 'assets/mastercard.svg';
import './singlecard.scss';
import '../../containers/Admin/allcards/slider.css';
import { openUpdateBox } from 'appRedux/actions/update';
import { useDispatch } from 'react-redux';
import { getCardImage } from 'helpers/utils';
// import { cardColors } from "helpers/data";

export const Singlecard = props => {
  const [show, setShow] = useState(false);
  var dispatch = useDispatch();

  var openUpdateModal = () => {
    dispatch(openUpdateBox());
  };

  console.log(props.data);

  switch (props.data?.providerName) {
    case 'Mono':
    case 'Checkbook':
      return (
        <Virtualcard
          userdata={props.userdata}
          data={props.data}
          show={show}
          setShow={setShow}
          goTo={props.goTo}
          from={props.from}
          openUpdateModal={openUpdateModal}
        />
      );
    case 'Stripe':
      return (
        <Founderscard
          userdata={props.userdata}
          data={props.data}
          show={show}
          setShow={setShow}
          goTo={props.goTo}
          from={props.from}
          details={props.details}
          openUpdateModal={openUpdateModal}
        />
      );
    case 'tyrus':
      return (
        <Founderscard
          userdata={props.userdata}
          data={props.data}
          show={show}
          setShow={setShow}
          goTo={props.goTo}
          from={props.from}
          details={props.details}
          openUpdateModal={openUpdateModal}
        />
      );
    default:
      return (
        <Founderscard
          userdata={props.userdata}
          data={props.data}
          show={show}
          setShow={setShow}
          goTo={props.goTo}
          from={props.from}
          details={props.details}
          openUpdateModal={openUpdateModal}
        />
      );
  }
};

export const Virtualcard = props => {
  const [show, setShow] = useState(false);
  // console.log('cardProvider :', props.data.cardBrand);
  // var  cardNumber = props.from ? props.data.cardNumber :props.data.cardNumber
  return (
    <div
      className={`ccard whiteText 
      ${props.data.cardColor === 'Yellow' ? 'bluebg' : 'bg-black'}
      `}
    >
      <div className="myccard"></div>

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <img
          src={props.data.cardBrand === 'MasterCard' ? Mastercard : Visa}
          alt="visa"
          style={{ width: '40px' }}
        />
        <img src={vwhite} alt="vesti white" style={{ width: '40px' }} />
      </div>

      {
        <p style={{ fontWeight: '400' }}>
          {show
            ? props.data.cardNumber.replace(/(\d{4})/g, '$1 ')
            : props.data.cardNumber
            ? 'XXXX XXXX XXXX' + props.data.cardNumber.slice(-4)
            : 'XXXXXX'}
          <i
            className={`fas fa-${show ? 'eye-slash' : 'eye'}`}
            onClick={() => setShow(!props.show)}
          ></i>
        </p>
      }

      <div className="cardBtm">
        <span className="">
          <p style={{ fontWeight: '300', fontSize: '13px', color: '#8A8A8B' }}>
            BALANCE
          </p>
          <p style={{ fontSize: '24px', fontWeight: '700' }}>
            $
            {props.data.providerName === 'Checkbook' ||
            props.data.balance === null ? (
              <p>***</p>
            ) : (
              parseFloat(props.data.balance / 100)
            )}
            {/* {props.from
              ? (props.data.balance / 100).toLocaleString('en-us')
              : (parseInt(props.data.balance) / 100).toLocaleString('en-us')} */}
          </p>
        </span>
        <p style={{ fontSize: '12px', fontWeight: '700' }}>
          {props.data.cardName.toUpperCase()}
        </p>
      </div>

      {/* <img
        src={getCardImage(props.data.cardColor)}
        className="gg"
        style={{
          position: 'absolute',
          width: '20rem',
          height: '17rem',
          right: '50px',
          bottom: '10px',
        }}
        alt="gg"
      /> */}
      {props.children}
    </div>
  );
};

export const Founderscard = props => {
  const [show, setShow] = useState(false);

  const [mycardColor, setMyCardColor] = useState('');

  useEffect(() => {
    if (props.data.cardColor == '1') {
      setMyCardColor('myccardgreen');
    } else if (props.data.cardColor == '2') {
      setMyCardColor('myccardpurple');
    } else if (props.data.cardColor == '3') {
      setMyCardColor('myccardorange');
    } else if (props.data.cardColor == '4') {
      setMyCardColor('myccardblue');
    } else if (props.data.cardColor == '5') {
      setMyCardColor('myccardskyblue');
    } else if (
      props.data.cardColor == '6' ||
      props.data.cardColor === 'Yellow'
    ) {
      setMyCardColor('myccardyellow');
    } else if (props.data.cardColor == '7') {
      setMyCardColor('myccardlightGreen');
    } else if (!props.data.cardColor) {
      setMyCardColor('myccardgreen');
    } else {
      setMyCardColor('myccardgreen');
    }
  }, [props.data]);

  // console.log(props.data.cardColor);
  // console.log(mycardColor);

  return (
    <div
      className={`ccard whiteText ${
        props.data.cardColor === 'Yellow' ? 'bluebg' : 'bg-black'
      }`}
    >
      <div className={`${mycardColor}`}>
        {mycardColor == 'myccardorange' ? (
          <div style={{ position: 'absolute', right: '10px', bottom: '0' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="82"
              height="198"
              viewBox="0 0 142 298"
              fill="none"
            >
              <path
                opacity="0.2"
                d="M60.7913 133.106C59.9377 134.73 59.0345 136.897 59.0345 136.897C59.0345 136.897 54.7077 134.685 53.2198 133.243C51.7319 131.754 51.6423 131.89 51.0104 129.86C50.3831 127.875 50.8783 126.744 49.8856 124.941C49.48 124.218 49.2985 123.453 49.1217 122.639C48.8482 121.419 48.6241 120.068 47.7658 118.713L54.1677 118.489L58.4923 118.352C58.5394 120.248 58.6738 122.415 58.8554 123.723C58.8554 123.767 58.8554 123.857 58.9002 123.949C59.2586 126.428 59.5746 127.693 60.6144 127.875C61.6472 128.007 62.6399 127.105 62.6399 127.105L62.8192 128.956C62.8192 128.956 61.6944 131.529 60.7913 133.106ZM44.3868 113.569C43.3965 113.435 42.0878 112.623 41.7294 110.142L48.8952 110.637L56.8723 111.223C57.0963 113.525 58.3579 114.7 58.3579 114.7V115.059L52.9038 116.638L47.4522 118.17C46.1907 116.053 45.4715 113.706 44.3868 113.569ZM140.699 219.648C140.699 217.618 140.475 215.812 139.664 214.773C137.905 212.384 138.22 209.36 137.725 207.014C137.183 204.667 137.454 204.216 136.688 202.998C135.877 201.825 134.66 199.795 134.66 199.795L140.338 187.387L135.605 178.589L130.602 177.368L125.511 187.342C125.511 187.342 123.799 186.259 122.898 185.534C121.995 184.814 116.409 173.174 114.784 169.517C113.162 165.818 111.042 162.841 109.106 160.45C107.211 158.058 106.536 157.473 104.6 156.479C102.662 155.44 105.232 154.72 101.804 153.004C100.229 152.192 98.7856 151.201 97.524 150.072C96.0362 148.762 94.9113 147.23 94.3242 145.603C93.7818 144.119 93.5555 143.576 93.513 143.394C93.6923 143.439 95.2226 143.892 95.7201 142.266C96.2624 140.552 94.2346 137.124 94.2346 137.124C94.2346 137.124 95.6777 132.835 95.133 130.58C95.133 130.535 95.133 130.446 95.0905 130.401V130.354C94.685 128.866 93.7371 127.875 93.2419 127.422C93.0603 127.24 92.926 127.15 92.926 127.15L92.3411 123.633C92.3411 123.633 92.9707 124.941 94.0082 123.586C95.001 122.054 95.001 120.609 94.1898 117.271C94.0082 116.549 93.6923 115.644 93.2867 114.653L101.941 112.757L112.08 110.548L102.164 110.501L91.1692 110.456C90.4477 109.33 89.6813 108.204 88.8277 107.118L102.841 96.6506L85.5808 103.78C85.0384 103.284 84.4088 102.831 83.8217 102.47C82.9658 101.884 81.9306 101.341 80.8035 100.845L84.3641 84.2878L76.4318 99.2686C75.682 99.0703 74.9156 98.8979 74.1422 98.761C72.0601 98.3904 70.2681 97.0708 69.1409 95.2814L58.945 79.0991L66.5589 98.7256C65.1182 98.9947 63.5855 99.6273 62.3688 100.395C62.0552 100.621 61.7369 100.845 61.4233 101.072L41.2318 90.2886L59.1265 103.78C58.0867 105.312 57.4571 106.712 57.1411 107.93L47.7658 108.968L41.6822 109.599C41.6374 109.464 41.6374 109.33 41.6374 109.148C41.5478 106.938 40.1519 100.938 38.124 94.5307C37.1313 91.417 36.0042 88.2585 34.8323 85.369C33.3043 81.6699 32.5804 79.7318 32.13 78.2422L32.0852 78.1974C31.6349 76.4363 31.2717 74.4061 30.5053 71.3373C28.8382 64.9753 29.107 63.2166 27.9823 59.1114C26.8127 55.0039 25.5041 51.5738 23.745 49.1849C21.9435 46.7935 21.4931 46.6566 21.4931 46.6566L21.8515 43.7695L22.1228 42.0108C22.1228 42.0108 23.745 41.2412 23.8818 40.4315C24.061 39.6195 23.0235 38.536 23.0235 38.536C23.0235 38.536 30.0573 37.3627 30.1021 36.1895C30.1469 35.0162 32.354 34.2962 31.4957 32.4006C30.6421 30.505 29.3806 29.2869 30.1469 27.887C30.8661 26.532 32.3092 25.3139 32.3092 25.3139L30.2365 25L30.8661 23.3758L27.8031 23.737L27.3975 21.9759L22.9339 22.6086C22.9339 21.9311 22.7994 21.2111 22.665 20.5336C22.5283 19.5846 22.3939 18.7725 22.8891 18.5483C23.745 18.2319 24.153 17.2381 25.1881 15.2528C26.2681 13.2226 31.4532 9.29686 31.7244 7.44846C31.9932 5.64256 32.6252 4.15532 32.0852 3.25119C31.5429 2.30457 30.0574 5.23654 28.1167 6.41215C26.136 7.62788 25.2329 6.04858 23.4314 7.04242C21.6299 8.08111 23.7002 3.11667 21.8515 2.2149C20.0523 1.31077 18.1589 3.56756 16.4022 5.50802C14.6432 7.40362 13.516 5.95887 11.2147 8.8011C8.91798 11.5985 10.7219 15.8406 12.3418 18.1422C13.0657 19.4949 13.2897 20.2621 13.3368 21.0742L11.2594 20.1724L9.45791 22.3371L6.21338 21.7517L5.58381 23.2861L3.24229 22.9698L3.77998 24.5939L2.38165 24.5042L1.79688 24.4145C1.79688 24.4145 2.0232 24.5491 2.33917 24.7734C3.06071 25.2714 4.32224 26.3077 4.41184 27.5707C3.95911 28.3403 3.60068 30.819 2.92394 31.3619C2.292 31.9025 2.02326 32.7594 2.87685 33.5266C3.69036 34.341 4.41189 35.8755 6.16859 36.461C6.75573 36.6852 7.51974 37.0015 8.19648 37.273C7.11652 37.993 8.33318 39.4377 10.3162 40.5213C10.7218 41.3782 11.1251 42.6411 11.1251 42.6411L11.0355 44.7185C11.0355 44.7185 9.36601 44.355 9.0524 45.8918C8.69163 47.4687 10.1347 48.8237 10.1347 48.8237C10.1347 48.8237 9.82114 48.8685 9.50281 49.1849C9.50281 49.2297 9.50281 49.2297 9.50281 49.2297C9.45801 49.2746 9.45792 49.2746 9.41312 49.3194C9.36596 49.3643 9.36599 49.4092 9.32354 49.454C9.32354 49.4989 9.27645 49.546 9.27645 49.5909C9.27645 49.6358 9.23397 49.6806 9.23397 49.7255C9.23397 49.7703 9.18918 49.7703 9.18918 49.8151V49.7703C9.14438 49.9946 9.0996 50.2212 9.0996 50.4927C9.05244 52.1168 10.5874 53.1531 10.5874 53.1531C10.5874 53.1531 8.64912 53.7858 9.63948 55.816C10.6298 57.8485 11.8937 58.2073 11.8937 58.2073C11.8937 58.2073 12.4786 61.6822 12.2546 63.6227L14.0112 64.9304L12.2546 63.6675C12.2074 63.9838 12.1178 64.253 12.0282 64.4347C11.3515 65.9243 11.4434 67.277 11.4434 67.277C11.4434 67.277 10.2267 67.8647 10.8539 69.1725C11.4434 70.4355 12.3418 70.4803 12.3418 72.8717C12.3418 75.263 12.8393 75.4448 12.8393 75.4448C12.8393 75.4448 14.3271 79.0991 15.5887 79.144C16.8502 79.1888 18.2486 77.6544 18.291 76.8872C18.291 76.12 18.7437 81.9862 19.2837 85.7326C19.7789 89.5214 21.446 102.243 23.8818 108.879C25.8177 114.065 26.7656 117.493 27.532 120.337C27.7135 121.152 27.9352 121.917 28.1167 122.639C29.0175 126.024 29.6942 129.001 28.7038 130.897C27.7135 132.747 24.2402 140.507 23.8818 146.508C23.5658 152.508 22.5283 156.479 25.5489 156.389C28.6119 156.252 28.975 157.832 29.8286 157.336C30.2365 157.109 30.2365 157.969 30.279 159.184C30.3733 160.45 30.5525 162.121 31.5428 163.202C32.512 164.262 34.3583 167.128 34.6955 170.242C35.4194 176.469 35.0138 176.875 36.6809 181.521C38.3928 186.167 38.8903 187.432 38.8903 187.432C38.8903 187.432 32.4436 195.057 29.6494 205.345C29.1542 207.058 28.7935 208.73 28.4799 210.352V210.399V210.441C26.9 218.609 27.2183 225.422 28.3879 227.452C29.7838 229.891 31.0005 231.784 31.0005 231.784C31.0005 231.784 28.5694 240.582 28.7038 247.893C28.8382 255.157 29.107 260.029 29.8286 263.549C30.5053 267.069 31.2717 269.278 31.2717 269.278C31.2717 269.278 31.4084 272.437 32.0403 274.83C32.2195 275.506 32.3541 276.226 32.4437 276.906C32.7148 278.575 32.8044 279.972 32.8044 279.972C32.8044 279.972 32.262 295.944 33.1651 301.449C34.021 306.954 34.1579 309.752 34.7427 313.543C35.3298 317.287 36.6809 321.98 38.032 326.944C39.3855 331.859 41.3214 337.546 41.3214 337.546C41.3214 337.546 41.4581 340.343 40.7838 347.201C40.6894 348.013 40.5999 348.962 40.4678 350.043C39.9255 354.602 39.0247 361.19 37.94 367.007L20.6796 426.023H130.828L115.685 367.007C115.28 362 114.334 352.796 114.018 350.043C113.928 345.801 114.919 340.478 114.919 340.478C114.919 340.478 118.211 338.946 117.534 335.108C116.815 331.227 116.317 321.843 116.317 321.843C116.317 321.843 118.166 322.52 117.76 317.018C117.489 313.677 116.451 291.296 115.685 274.198C115.145 263.098 114.74 254.255 114.74 254.255C114.74 254.255 117.987 255.157 119.564 256.512C121.184 257.82 128.26 258.044 131.821 251.998C135.424 245.908 136.869 241.08 137.183 237.922C137.454 235.485 139.348 232.055 140.159 229.211C140.159 229.168 140.159 229.168 140.159 229.121C140.159 229.121 140.159 229.121 140.159 229.079C140.385 228.311 140.475 227.589 140.475 226.912C140.385 225.243 140.699 222.625 140.699 220.144V219.648Z"
                stroke="white"
                stroke-width="2.35798"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        ) : (
          <></>
        )}
      </div>

      {mycardColor == 'myccardpurple' ? (
        <div style={{ position: 'absolute', right: '0px', bottom: '0' }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="207"
            height="201"
            viewBox="0 0 197 301"
            fill="none"
          >
            <path
              opacity="0.2"
              d="M115.921 187.356H124.549L137.501 224.076H125.079L115.921 187.356ZM82.2818 224.076H69.9047L82.8572 187.356H91.4638L82.2818 224.076ZM99.3324 37.2933H101.264C103.244 110.843 96.8707 167.701 96.8707 167.701H89.1176C97.2385 134.151 99.3324 37.2933 99.3324 37.2933ZM96.8707 28.7035L97.7903 26.5902H99.6083V34.5823H97.861L96.8707 31.7582V28.7035ZM106.142 37.2933H108.052C108.052 37.2933 110.167 134.151 118.291 167.701H110.514C110.514 167.701 104.164 110.843 106.142 37.2933ZM107.8 26.5902H109.616L110.514 28.7035V31.7582L109.524 34.5823H107.8V26.5902ZM122.502 167.837C122.502 167.837 112.193 117.273 110.997 37.797L112.815 35.8931V25.4442L109.847 22.9402L112.077 20.3232V16.5813L108.696 18.9912C108.696 18.9912 107.109 17.3156 105.89 17.4992L104.992 0.943206H102.414L101.518 17.4992C100.276 17.3156 98.6863 18.9912 98.6863 18.9912L95.305 16.5813V20.3232L97.538 22.9402L94.5456 25.4442V35.8931L96.4108 37.797C95.1918 117.273 84.9062 167.837 84.9062 167.837H122.502ZM156.601 285.113L139.458 257.672H160.279L198.038 310.694H172.567L156.601 285.113ZM133.016 274.892C133.016 274.892 124.457 264.561 103.702 264.561C82.9727 264.561 74.0925 274.892 74.0925 274.892V264.398C74.0925 264.398 81.3834 255.902 103.725 255.902C126.044 255.902 133.016 264.561 133.016 264.561V274.892ZM50.7838 285.113L34.8156 310.694H9.36816L47.1501 257.672H67.924L50.7838 285.113ZM162.031 256.385L153.493 244.879H53.9129L45.3534 256.385L2.46875 314.16H41.6278L42.4767 310.694H63.0029C63.0029 310.694 63.0713 284.124 88.4951 274.205C88.5423 274.205 88.6106 274.181 88.6342 274.16C98.3185 270.416 109.135 270.439 118.819 274.181C144.337 284.079 144.382 310.694 144.382 310.694H164.906L165.757 314.16H204.94L162.031 256.385Z"
              stroke="white"
              stroke-width="1.76849"
              stroke-miterlimit="10"
            />
          </svg>
        </div>
      ) : (
        <></>
      )}

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          zIndex: '10',
        }}
      >
        {/* */}

        <p style={{ fontSize: '12px', fontWeight: '700' }}>
          {props.data.cardName.toUpperCase()}
        </p>
        {/* 
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="24"
          viewBox="0 0 54 36"
          fill="none"
        >
          <g opacity="0.7">
            <rect
              x="1.68325"
              y="1.75357"
              width="50.5788"
              height="32.8939"
              rx="5.83601"
              fill="white"
              fill-opacity="0.26"
              stroke="white"
              stroke-width="2.47588"
            />
            <path
              d="M1.27344 11.4023H11.608C15.5149 11.4023 18.682 14.5695 18.682 18.4763V19.9253M18.682 35.194V28.4482M18.682 28.4482V19.9253M18.682 28.4482H1.27344M18.682 19.9253H1.27344"
              stroke="white"
              stroke-width="2.47588"
            />
            <path
              d="M52.6719 11.3972H36.0923M36.0923 11.3972V19.9201M36.0923 11.3972V1.24219M36.0923 35.1889V28.4431M36.0923 28.4431V19.9201M36.0923 28.4431H52.6719M36.0923 19.9201H52.6719"
              stroke="white"
              stroke-width="2.47588"
            />
          </g>
        </svg> */}
        <img
          src={vwhite}
          alt="vesti white"
          style={{ width: '40px', zIndex: '10' }}
        />
      </div>

      {
        <p style={{ fontWeight: '400', zIndex: '10' }}>
          {show
            ? props.data.cardNumber.replace(/(\d{4})/g, '$1 ')
            : props.data.cardNumber
            ? 'XXXX XXXX XXXX' + props.data.cardNumber.slice(-4)
            : 'XXXXXX'}
          <i
            className={`fas fa-${show ? 'eye-slash' : 'eye'}`}
            onClick={() => setShow(!props.show)}
          ></i>
        </p>
      }

      <div className="cardBtm" style={{ zIndex: '10' }}>
        <span className="">
          {/* <p style={{ fontWeight: '300', fontSize: '13px', color: '#8A8A8B' }}>
            BALANCE
          </p> */}
          <p style={{ fontSize: '24px', fontWeight: '700' }}>
            $
            {props.from
              ? (props.data.balance / 100).toLocaleString('en-us')
              : (parseInt(props.data.balance) / 100).toLocaleString('en-us')}
          </p>
        </span>

        <img
          src={props.data.cardBrand === 'MasterCard' ? Mastercard : Visa}
          alt="mastercard"
          style={{ width: '40px' }}
        />
      </div>

      {/* <img
        src={getCardImage(props.data.cardColor)}
        className="gg"
        style={{
          position: 'absolute',
          width: '20rem',
          height: '17rem',
          right: '50px',
          bottom: '10px',
        }}
        alt="gg"
      /> */}
      {props.children}
    </div>
  );
};
